import { COMPOUND_BY_ID } from '../lib/compounds';
import { GOAL_BY_ID } from '../lib/goals';
import { buildVendorUrl } from '../lib/affiliate';

export function renderCompound(params: Record<string, string>) {
  const app = document.getElementById('app')!;
  const c = COMPOUND_BY_ID[params.id];
  if (!c) {
    app.innerHTML = `<h2>Not found</h2><p>No compound at <code>/c/${esc(params.id)}</code>.</p><p><a href="/">Back home</a></p>`;
    return;
  }
  const stars = '★'.repeat(c.evidence_stars) + '<span class="stars-empty">' + '★'.repeat(5 - c.evidence_stars) + '</span>';
  const dose = c.typical_dose_mg.min === c.typical_dose_mg.max
    ? `${c.typical_dose_mg.min} mg`
    : `${c.typical_dose_mg.min}–${c.typical_dose_mg.max} mg`;

  app.innerHTML = `
    <div class="detail-header">
      <h1>${esc(c.display_name)}</h1>
      <div class="sci">${esc(c.scientific_name)}</div>
      <div class="tags" style="margin-top:8px;">
        ${c.goals.map((g) => {
          const goal = GOAL_BY_ID[g];
          return `<a class="tag" href="/g/${esc(g)}" style="text-decoration:none;">${goal ? goal.icon + ' ' + esc(goal.label) : esc(g)}</a>`;
        }).join('')}
      </div>
    </div>

    <section class="detail-section">
      <p>${esc(c.description)}</p>
    </section>

    <section class="detail-section">
      <h3>What the research says</h3>
      <div class="kv">
        <div class="k">Evidence</div>
        <div class="v"><span class="stars">${stars}</span> &nbsp; (our subjective summary of the literature)</div>
        <div class="k">Typical dose</div>
        <div class="v">${dose}</div>
        <div class="k">Timing</div>
        <div class="v">${c.timing.join(', ')}</div>
        <div class="k">Cycle?</div>
        <div class="v">${c.cycle_required ? esc(c.cycle_pattern || 'Yes') : 'Not required'}</div>
        ${c.aliases.length ? `<div class="k">Also called</div><div class="v">${c.aliases.map(esc).join(', ')}</div>` : ''}
      </div>
    </section>

    ${c.warnings.length ? `
      <section class="detail-section">
        <h3>Caveats</h3>
        <div class="warnings"><ul>${c.warnings.map((w) => `<li>${esc(w)}</li>`).join('')}</ul></div>
      </section>
    ` : ''}

    <section class="detail-section">
      <h3>Sources</h3>
      <div class="refs">
        <ul>${c.references.map((r) => `<li><span class="src">${esc(r.type)}</span><a href="${esc(r.url)}" target="_blank" rel="noopener">${esc(r.note)}</a></li>`).join('')}</ul>
      </div>
      <p class="footer-disclosure" style="font-size:12px;margin-top:8px;">All descriptions on this page are paraphrased summaries. Read the original sources above for the full picture.</p>
    </section>

    <section class="detail-section">
      <h3>Buy from</h3>
      <div class="vendor-row">
        ${c.affiliate_vendors.map((v) => `<a class="vendor-btn" href="${esc(buildVendorUrl(v.url_template))}" target="_blank" rel="noopener nofollow sponsored">${esc(v.name)} →</a>`).join('')}
      </div>
      <span class="vendor-disclosure">Vendor links may be affiliate. App stays free; merchants pay a small cut. Your tracking data stays yours.</span>
    </section>

    <p style="margin-top:24px;"><a href="/">← All compounds</a></p>
  `;
}

function esc(s: string) {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
